import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getUniversityPrograms = async () => {
    const { path, method } = endpoints.educationCareerPath.getUniversityPrograms;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(
        `${host}${path}`,
      method,
      {},
      {},
    ));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
